/*
Polling component working with promises

On start it returns a promise that resolves when the provided callback is resolved with the first argument set
and rejects when the timeout is reached or the provided callback is resolved with the second argument set

It exposes the following interface:
  start: starts the polling
  stop: stops the polling
  reset: calls clear and starts the polling
  clear: restarts the polling counter, clears the interval and deletes the promise handler

Ex.

var pollingHelper = new PollingHelper (callbackFunction, frequency, timeout);
pollingHelper.start().then(...).fail(...);

*/

define(['jquery', 'underscore'], function ($, _) {
  'use strict'
  var defaultFrequency = 1000
  var defaultTimeout = 10000

  var Polling = function (callback, frequency, timeout) {
    if (!callback || !_.isFunction(callback)) {
      throw new Error('Provide a polling callback')
    }

    this.callback = callback
    this.frequency = frequency || defaultFrequency
    if (timeout !== false) {
      this.timeout = timeout || defaultTimeout
    }
    this.timesExecuted = 0
    this.$deferred = $.Deferred()
  }

  Polling.prototype.start = function () {
    if (!this.$deferred) {
      this.$deferred = new $.Deferred()
    }
    this.intervalHandler = setInterval(
      function () {
        if (
          this.timeout && this.frequency * this.timesExecuted >= this.timeout
        ) {
          this.$deferred.reject()
          this.clear()
          return
        }
        $.when(this.callback()).then(
          function (success, error) {
            if (success) {
              this.$deferred.resolve(success)
              this.clear()
            }
            if (error) {
              this.$deferred.reject(error)
              this.clear()
            }
          }.bind(this)
        )
        this.timesExecuted++
      }.bind(this),
      this.frequency
    )
    return this.$deferred.promise()
  }
  Polling.prototype.stop = function () {
    clearInterval(this.intervalHandler)
  }
  Polling.prototype.reset = function () {
    this.clear()
    return this.start()
  }
  Polling.prototype.clear = function () {
    this.timesExecuted = 0
    this.stop()
    delete this.$deferred
  }

  return Polling
})
